import { gql, useMutation, useQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import ExpensesListMapComponent from "../../Pages/SalesBillSetup/LinkSaleExpenses/ExpensesListMapComponent/ExpensesListMapComponent";
import Button from "../Button/Button";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import "./SideNavbar.scss";

import { GetUserInfo } from "../../../CommonFunction/GetUserInfo";
import { ErrorToast, SuccessToast } from "../ToastComponent/RectHotToast";
import { GetQuickLinks } from "../../../Utils/AllPagesQuriesAndMutations";
import Input from "../Input/Input";
import ExpensesListMapComponentDrag from "../../Pages/SalesBillSetup/LinkSaleExpenses/ExpensesListMapComponent/ExpensesListMapComponentDrag";
// import { getSalesInvoiceTypeDetailsAndItsFormula } from "../../../Utils/AllPagesQuriesAndMutations";

const AllData = gql`
  query GetAllPageRightsForQuickLinks($Role_Id: ID, $keyword: String) {
    GetAllPageRightsForQuickLinks(Role_Id: $Role_Id, keyword: $keyword) {
      Page_Name
      _id
      Page_Access
    }
  }
`;

const EditQuickLinks = gql`
  mutation AddDataToQuickLinks($createInput: [QuickLinksInput!]) {
    AddDataToQuickLinks(createInput: $createInput) {
      Page_Rights {
        _id
        Unique_Id
        Page_Name
        Page_Access
        Role_Id
        Route
        Module_Right_Id
        Page_Id
        Is_Add
        Is_View
        Is_Edit
        Is_Delete
        Is_Merge
        Export
        Is_Lock
        Is_Unlock
        Audit
        UnAudit
        Serial_No
        createdAt
        updatedAt
      }
      _id
    }
  }
`;
function updateSessionBookmarks(newData) {
  // Save to sessionStorage:
  sessionStorage.setItem("userData", JSON.stringify(newData));

  // Dispatch a custom event we can listen for in our component:
  window.dispatchEvent(new Event("sessionStorageUpdated"));
}
const SideNavbar = ({ ParentPortalCloseFunction, show }) => {


  let info = GetUserInfo();
  const Form_Key = "Quick Links";
  const [EditQuickLink, { loading: EditQuickLinkLoading }] = useMutation(EditQuickLinks);
  const { refetch: pageRightsRefetch } = useQuery(AllData, {
    variables: {
      Role_Id: info.userDetails[0].Role._id,
    },
    fetchPolicy: "network-only",
  });

  const companyData = JSON.parse(sessionStorage.getItem("CompanyCode"));
  // console.log(companyData, "companyData");
  const { data, refetch: userPageLinkRefetch } = useQuery(GetQuickLinks, {
    variables: {
      User_ID: info.userDetails[0]._id,
      companyId: companyData.id,
    },
  });

  const [SearchValue, setSearchValue] = useState(null);
  const [toggle, settoggle] = useState(show);
  const [selected, setSelected] = useState({});
  const [remove, setRemove] = useState(-1);
  const pageDataRef = useRef([]);

  const [selectedItemId, setSelectedItemId] = useState([]);
  const [allItemId, setAllItemId] = useState([]);
  const [type, setType] = useState("Quick Links");
  const [AvailableExpenseList, setAvailableExpenseList] = useState(data ? data.SalesExpense_Formula : []);
  const [SelectedExpense, setSelectedExpenses] = useState([]);
  const [dataFetchedFirstTime, setDataFetchedFIrstTime] = useState(true);
  // const navigate = useNavigate();
  const QuickLinksLoadingState = EditQuickLinkLoading ? true : false;

  useEffect(() => {
    getExpensdeList();
  }, []);
  useEffect(() => {
    if (SearchValue !== null) {
      // 1. Guard against `pageDataRef.current` being undefined:
      const baseArray = pageDataRef.current || [];
      // 2. Filter by whatever the user typed:
      const filtered = baseArray.filter(el =>
        el.Page_Name.toLowerCase().includes(SearchValue)
      );
      // 3. Update your state
      setAvailableExpenseList(filtered);
    }
  }, [SearchValue]);

  const Closeformfunction = () => {
    settoggle(false);
    ParentPortalCloseFunction();
  };

  function handleAdd() {
    console.log(selectedItemId, "*******", allItemId, "****", selected, "*****", allItemId[selected])
    if (selectedItemId.includes(selected._id)) {
      return;
    } else {
      if (allItemId.includes(selected._id)) {
        setSelectedExpenses([...SelectedExpense, selected]);
        setSelectedItemId([...selectedItemId, selected._id]);
      } else {
        return;
      }
    }
  }

  const AddAll = () => {
    setSelectedExpenses([...AvailableExpenseList]);
    setSelectedItemId([...allItemId]);
  };

  function RemoveAll() {
    setSelectedExpenses([]);
    setSelectedItemId([]);
    setRemove(-1);
  }

  function handleRemove() {
    const filterItem = SelectedExpense.filter((el, i) => i !== remove);
    const filterSelectedId = selectedItemId.filter((el, i) => i !== remove);
    setSelectedExpenses(filterItem);
    setSelectedItemId(filterSelectedId);
  }

  function HandleUpArrow() {
    if (remove === 0 || remove === -1) {
      setRemove(remove);
    } else {
      setRemove(remove - 1);
      let temp = SelectedExpense[remove];
      SelectedExpense[remove] = SelectedExpense[remove - 1];
      SelectedExpense[remove - 1] = temp;
    }
  }

  function HandleDownArrow() {
    if (remove === SelectedExpense.length - 1 || remove === -1) {
      setRemove(remove);
    } else {
      setRemove(remove + 1);
      let temp = SelectedExpense[remove];
      SelectedExpense[remove] = SelectedExpense[remove + 1];
      SelectedExpense[remove + 1] = temp;
    }
  }

  function RemoveData(i) {
    setRemove(i);
  }

  function SelectedData(i, el) {
    setSelected(el);
  }

  const submit = async () => {
    if (type === "Quick Links") {
      let Links = SelectedExpense.map((el, i) => {
        return { Page_Rights_ID: el._id, Serial_No: i + 1 };
      });
      await EditQuickLink({
        variables: {
          createInput: Links,
        },
      })
        .then(({ data }) => {
          SuccessToast("Quick Links updated");
          let d = data.AddDataToQuickLinks;
          let BookMarks = sessionStorage.getItem("userData") && JSON.parse(sessionStorage.getItem("userData"));
          BookMarks.BookMarks = [d];
          updateSessionBookmarks(BookMarks);
        })
        .catch((err) => {
          settoggle(toggle);
          ErrorToast("Something went wrong! Please Check fields and try again.");
        });
    } else {
      return;
    }
  };

  const getExpensdeList = () => {
    if (type === "Quick Links") {
      if (info) {
        pageRightsRefetch({
          Role_Id: info.userDetails[0].Role._id,
          keyword: SearchValue,
        }).then((res) => {
          //Page_Access:true/false
          const allPages = res.data.GetAllPageRightsForQuickLinks?.filter(el => el.Page_Access);
          pageDataRef.current = allPages;           // <-- store the array
          setAvailableExpenseList(allPages);

          if (res.data.GetAllPageRightsForQuickLinks) {
            let temp = res.data.GetAllPageRightsForQuickLinks.map((el) => el._id);
            setAllItemId(temp);
          }
        });

        if (dataFetchedFirstTime) {
          userPageLinkRefetch({ variables: { User_Id: info.userDetails[0]._id, companyId: companyData.id } })
            .then((res) => {

              let arr = res.data.getallQuickLinksWithUserId[0]?.Page_Rights?.map((el) => el) || [];
              let temp2 = res.data.getallQuickLinksWithUserId[0]?.Page_Rights?.map((el) => el._id) || [];
              setSelectedExpenses(arr);
              setSelectedItemId(temp2);
            })
            .catch((err) => {
              settoggle(toggle);
              ErrorToast("Something went wrong! Please Check fields and try again.");
            });
        }
        setDataFetchedFIrstTime(false);
      }
    }
  };

  useEffect(() => {
    getExpensdeList();
  }, [type]);

  const SaveAndClose = () => {
    if (type === "Quick Links") {
      submit();
      Closeformfunction();
    } else {
      return;
    }
  };

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination || source.index === destination.index) return;

    const items = Array.from(SelectedExpense);
    const movedItem = items.splice(source.index, 1)[0];
    items.splice(destination.index, 0, movedItem);
    // console.log(destination.index, "destination.indexdestination.index")
    // setSelected(destination.index)
    setSelectedExpenses(items);

    // Update selectedItemId in same order
    const ids = items.map((item) => item._id);
    setSelectedItemId(ids);
  };

  return (
    <>
      <div className="LinkSaleMainDiv">
        <Reactportal open={toggle} onClose={Closeformfunction} TypeOfPortal={"Side Navbar"} TypeOfId={"Account Id :"}>
          <div className="LinkSaleExpenses_MainDiv">
            <div className="SearchContainer">
              <Input
                InputConfig={{}}
                value={SearchValue}
                type="text"
                name="Search_Value"
                handleBlur={() => { }}
                label={"Search Page"}
                modalform={true}
                Iconinside={true}
                transactions={true}
                TypeOfPortal={"Table Key"}
                handleInputChange={(e) => {
                  // if (e.target.value) {
                  setSearchValue(e.target.value.toLowerCase());
                  // }
                }}
                Tax_Type={true}
                formkey={Form_Key}
              />
            </div>
            <div className="LinkSaleExpenses_subdiv">
              <ExpensesListMapComponent
                value={AvailableExpenseList}
                name={"Available Pages"}
                Setfunction={SelectedData}
                HighlightData={selected}
              />

              <div className="MiddleDiv">
                <div className="MiddleDiv_subdiv">
                  <Button name="getExpenses1" text="Add" action={handleAdd} />
                  <div className="Arrows_Div">
                    <AiOutlineArrowUp size={35} onClick={HandleUpArrow} />
                    <br />
                    <AiOutlineArrowDown size={35} onClick={HandleDownArrow} />
                  </div>
                  <Button name="getExpenses1" text="Add All" action={AddAll}></Button>
                  <Button name="getExpenses1" text="Remove" action={handleRemove} />
                  <Button name="getExpenses1" text="Remove All" action={RemoveAll}></Button>
                </div>
              </div>

              {/* <ExpensesListMapComponent
                value={SelectedExpense}
                name={"Selected Quick Link"}
                Setfunction={RemoveData}
                HighlightData={remove}
              /> */}
              <ExpensesListMapComponentDrag
                value={SelectedExpense}
                name={"Selected Pages"}
                Setfunction={RemoveData}
                HighlightData={remove}
                handleDragEnd={handleDragEnd}
              />
            </div>
            <p className="SelectedExpenses">Selected Links : {SelectedExpense.length}</p>
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            // submitform={submit}
            SaveAndClose={SaveAndClose}
            handleformclose={() => {
              Closeformfunction();
              settoggle(!toggle);
            }}
            // submitType={"Save"}
            loadingState={QuickLinksLoadingState}
          />
        </Reactportal>
      </div>
    </>
  );
};

export default SideNavbar;
